import { AdvertiseThankYou } from '@/components/advertise/AdvertiseThankYou';
import { ADVERTISE_BUILDERS } from '@/constants/testIds/advertise';

export default function BuildersThankYou() {
  return (
    <AdvertiseThankYou
      testId={ADVERTISE_BUILDERS.thankYouHeading}
      heading="Request received!"
      subtitle="Our new-construction team will reach out within 1 business day to scope your Community Boost plan."
      secondaryLinks={[{ to: '/', label: 'Back to casahom', variant: 'outline' }]}
    />
  );
}
